import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FarmerDetails } from '../models/farmer-details.model';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';
import { CryptoJsService } from './crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService extends BaseService {

  constructor(
    private _http: HttpClient, 
    tokenService: TokenService,
    private cryptoJsService: CryptoJsService
  ) { super(tokenService); }

  getOTP(reqBody: any) {
    return this._http.post<any>(`${environment.apiUrl}Login/GetOTP`, reqBody)
  }

  validateOTP(body: any) {
    return this._http.post(environment.apiUrl + 'Auth/ValidOtpToken', body)
  }
  // validateOTP(credentials: any){
  //   return this._http.post(environment.apiUrl + 'Auth/ValidOtpToken', credentials)
  // }

  login(reqBody: any) {
    return this._http
      .post<any>(`${environment.apiUrl}auth/login`, reqBody)
      .pipe(
        map(user => {
          // window.sessionStorage.setItem("token", JSON.stringify(user));
          window.sessionStorage.setItem("token", user.data);
          this.tokenService.authenticate(user);
          return user;
        })
      );
  }
  vendorLogin(reqBody) {
    return this._http
      .post<any>(`${environment.apiUrl}Auth/VendorLogin`, reqBody)
      .pipe(
        map(user => {
          // window.sessionStorage.setItem("token", JSON.stringify(user));
          window.sessionStorage.setItem("token", user.data);
          this.tokenService.authenticate(user);
          return user;
        })
      );
  }

  // getInitialToken() {
  //   return this._http.get(environment.apiUrl + 'Auth/GetToken')
  // }

  getInitialToken() {
    return this._http.post<any>(environment.apiUrl + 'Auth/GetTokenInternal', {})
  }

  getOTPforUsers(reqBody: any) {
    return this._http.post(environment.apiUrl + 'Login/GetOtpForUser', reqBody)
  }

  generateOtpForUserForVenReg(reqBody: any) {
    return this._http.post(environment.apiUrl + 'Login/GenerateOtpForUserForVenReg', reqBody)
  }
  
  changePasswordForUser(reqBody) {
    return this._http
    .post<any>(`${environment.apiUrl}Login/ForgotPassword`, reqBody );
  }

  forgotPasswordVendorReg(reqBody) {
    return this._http
    .post<any>(`${environment.apiUrl}Login/ForgotPasswordVendorReg`, reqBody );
  }
  
  activityDataTimeRecord(reqBody) {
    return this._http.post<any>(`${environment.apiUrl}Login/InsertUserActivityTracker`, reqBody);
  }
  
  getTargetMasterPublic() {
    return this._http.get(environment.apiUrl + 'Department/GetTargetMasterPublic')
  }
}
